import { createSlice } from "@reduxjs/toolkit";
import getNotificationCount from "@custom/rtk-apis/report/notificationCount";

const initialState = {
  status: "",
  result:null,
  msg: "",
  loading: false,
  error: ""
};

const getNotificationCountSlice = createSlice({
  name: "getNotificationCountSlice",
  initialState,
  reducers: {revertStatus (state:any) { state.status = ""; }},
  extraReducers: (builder) => {
    console.log("----------", builder)
    builder
      .addCase(getNotificationCount.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(getNotificationCount.fulfilled, (state, { payload }) => {
        console.log("Fulfilled", payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(getNotificationCount.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getNotificationCountSlice.reducer;
export const { revertStatus } = getNotificationCountSlice.actions;
